import React from "react";
import classNames from "classnames";
import Button from "../../components/Button";
import { FORM_SUBMIT_ID } from "../../constants";

interface Props {
  className?: string;
  onClick(id: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void;
  title?: string;
}

const FormSubmit = ({ className, onClick, title }: Props) => (
  <Button
    id={FORM_SUBMIT_ID}
    onClick={onClick}
    value=""
    ui={{
      attributes: {
        classNames: {
          widget: classNames("mb-4", className)
        },
        title: title || "Odeslat"
      },
      type: "submit",
      widget: "Button"
    }}
  />
);

export default FormSubmit;
